import { type RouteObject } from 'react-router';
import { standaloneLayout } from '@/app/layouts';
import { ROUTES } from '@/shared/routing';
import type { NavigationGuards } from '../navigation.guard';

/** 권한 부여 화면 (`/permission`, 네이티브 전용). */
export function createPermissionRoute(guards: NavigationGuards): RouteObject {
  return {
    element: standaloneLayout({ width: 'sm' }), // TODO: 라우트별 width 값 지정 ('sm'|'md'|'lg'|'full')
    path: ROUTES.PERMISSION,
    children: [
      {
        index: true,
        loader: guards.requireNative,
        lazy: { Component: () => import('@/pages/permission').then((m) => m.PermissionPage) },
      },
    ],
  };
}
